import Login from "./Login";
import LoginHybrid from "./LoginHybrid";

function LoginWrapper() {
  const host = window.location.hostname;
  // console.log("Current host:", host);

  const useHybrid =
    host === "localhost" ||
    host === "multiapp.ac" ||
    host === "www.multiapp.ac";

  return useHybrid ? <LoginHybrid /> : <Login />;
}

export default LoginWrapper;
